<template>
  <div class="grid-view">
    <div class="main-content" style="margin-left: 10px;">
      <search-item
        ref="searchItem"
        config-module="225600"
        :show-more-scheme="true"
        :show-simple="false"
        :expand-adv="true"
        :custom-search-items="customSearchItems"
        @advSearchItemCallBack="queryHandler"
      >
        <div slot="operations">
          <el-button type="success" no="view" @click="toProcess">{{ $t('CargoMsg.Cargo_Handled') }}</el-button>
          <el-button type="success" no="edit" @click="toDeclare">{{ $t('CargoMsg.Cargo_GoToDeclare') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="225600"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="225600"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import {
  getWarningDeclareParams,
  processOpenPriceWarning,
  queryAviationExchangePriceWarning
} from '@/api/sysManage/aviationExchangePrice'
import { doJumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getDataMapping } from '@/api/price/openPrice'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import $store from '@/store'

export default {
  name: 'AviationExchangePriceWarning',
  components: { searchItem },
  data() {
    return {
      showSimple: true,
      TYPE_NAMES: TYPE_NAMES,
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        }
      },
      gridApi: null,
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  doJumpFinaceOrBusiness(this, value, 'SE', params.data.branchId, true)
                }
              }
            }
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          colId: 'lob',
          field: 'lob',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_WarningReason'),
          colId: 'warningType',
          field: 'warningType',
          cellRenderer: (params) => {
            return ColumnUtils.openPriceWarningTypesLabelFun(params.value)
          },
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.WarningTime'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessStatus'),
          colId: 'jobState',
          field: 'jobState',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: 'etd',
          colId: 'etd',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          colId: 'pol',
          field: 'pol',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_PlaceOfDelivery'),
          colId: 'pod',
          field: 'pod',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'opId',
          colId: 'opId',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'salesId',
          colId: 'salesId',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRate'),
          colId: 'priceAmount',
          field: 'priceAmount',
          width: 100,
          cellRenderer: (params) => {
            if (!params.value) {
              return 0
            }
            return 'USD:$' + params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FilingBatchNo'), colId: 'filingBatchNo', field: 'filingBatchNo', initialWidth: 150, minWidth: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FilingState'), colId: 'filingState', field: 'filingState', initialWidth: 130, minWidth: 130,
          cellRenderer: (params) => {
            if (!params.data.filingBatchNo) {
              return ''
            }
            return ColumnUtils.OpenPriceBatchStateLabelFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_WarningMessage'),
          colId: 'warningInfo',
          field: 'warningInfo',
          width: 500
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessingStatus'), colId: 'warningState', field: 'warningState', initialWidth: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.OpenPriceWarningStateLabelFun(params.value)
          }
        }
      ],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      companyCodeMappings: [], // 公司代码
      laneMappings: [], // 航线
      eqTypeMappings: [], // 尺码
      eqSizeMappings: [], // 箱型
      cargoTypeMappings: [], // 货种
      seaportMappings: [], // 海港
      selectedRows: [],
      customSearchItems: [],
      loading: false
    }
  },
  async created() {
    await this.initDataMapping()
  },
  activated() {},
  methods: {
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryAviationExchangePriceWarning(this.filter).then(res => {
        this.rowData = res.data.list
        this.gridApi.refreshCells({ force: true })
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    async initDataMapping() {
      await getDataMapping().then(res => {
        if (res && res.data) {
          const dataMapping = res.data
          // 分公司代码
          this.companyCodeMappings = dataMapping.companyCodes || []
          // 航线
          this.laneMappings = dataMapping.lanes || []
          // 箱型
          this.eqTypeMappings = dataMapping.eqTypes || SeaExportConstants.SEA_EXPORT_BOX_TYPES
          // 箱尺寸
          this.eqSizeMappings = dataMapping.eqSizes || []
          // 货物类型
          this.cargoTypeMappings = dataMapping.cargoTypes || []
          // 海港
          this.seaportMappings = dataMapping.seaports || []
        }
      })
    },
    toProcess() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckWarningToProcess'))
        return
      }
      const uuids = []
      for (const warning of this.selectedRows) {
        uuids.push(warning.uuid)
      }
      processOpenPriceWarning(uuids).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SelectedWarningMarkedProcessed'))
        this.selectedRows = []
        this.fetchDataByPage()
      }).finally(() => {
      })
    },
    async toDeclare() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectInfoToDeclare'))
        return
      }
      // 将状态为未处理的uuid拿出来
      const unProcessedKeys = []
      const jobKeys = []
      for (const row of this.selectedRows) {
        if (row.warningState === SystemConstants.OPEN_PRICE_WARNING_UN_PROCESSED.code) {
          unProcessedKeys.push(row.uuid)
        }
        jobKeys.push(row.jobUuid)
      }
      // 将状态变更为已处理
      if (unProcessedKeys.length > 0) {
        await processOpenPriceWarning(unProcessedKeys).then(res => res.data)
      }

      // 获取申报数据-后续填充到运价批次
      const warningDeclareParams = await this.getWarningDeclareParamData(jobKeys)

      // 跳转到配置页面并传递rowData参数
      this.$router.push({
        name: 'OpenPriceBatch',
        params: {
          data: warningDeclareParams,
          fromDeclare: true
        }
      })
    },
    async getWarningDeclareParamData(jobKeys) {
      if (!jobKeys || jobKeys.length === 0) {
        return null
      }
      const branchId = this.$store.getters.currentOfficeId
      const warningDeclareParams = await getWarningDeclareParams(jobKeys, branchId).then(res => res.data)
      if (warningDeclareParams && warningDeclareParams.length > 0) {
        for (const warningDeclare of warningDeclareParams) {
          warningDeclare.companyCode = this.getMappingTargetValue(warningDeclare.companyCode, this.companyCodeMappings)
          warningDeclare.lineCode = this.getMappingTargetValue(warningDeclare.lineCode, this.laneMappings)
          warningDeclare.pol = this.getMappingTargetValue(warningDeclare.pol, this.seaportMappings)
          warningDeclare.pod = this.getMappingTargetValue(warningDeclare.pod, this.seaportMappings)
          warningDeclare.eqType = this.getMappingTargetValue(warningDeclare.eqType, this.eqTypeMappings)
          warningDeclare.eqSize = this.getMappingTargetValue(warningDeclare.eqSize, this.eqSizeMappings)
          warningDeclare.cargoType = this.getMappingTargetValue(warningDeclare.cargoType, this.cargoTypeMappings)
        }
      }
      return warningDeclareParams
    },
    // 获取映射后的值
    getMappingTargetValue(sourceValue, mappings) {
      if (!mappings || mappings.length === 0 || !sourceValue) {
        return sourceValue
      }
      for (const mapping of mappings) {
        if (mapping.sourceValue === sourceValue) {
          return mapping.targetValue
        }
      }
      return sourceValue
    }
  }
}
</script>

<style scoped>

</style>
